import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllRmLevelsResponseModel, RmLevelDropDownDto, RmLevelDropDownResponseModel, RmLevelDto, RmLevelResponseModel, } from '@gtpl/shared-models/masters';
import { RmLevel } from './rm-level-entity';
import { RmLevelAdapter } from './dto/rm-level.adapter';
import { RmLevelDTO } from './dto/rm-level.dto';
import { RmLevelIdRequest } from './dto/rm-level-id.request';
import { RmLevelRequest } from './dto/rm-level.request';

@Injectable()
export class RmLevelService {

    constructor(
        @InjectRepository(RmLevel) private levelRepository: Repository<RmLevel>,
        private levelAdapter: RmLevelAdapter,
      ) { }

      async getLevelWithoutRelations(levelName: string): Promise<RmLevel> {
         console.log(levelName);
            const response = await this.levelRepository.findOne({
            where: {levelName: Raw(alias => `level_name = '${levelName}'`)},
            });
            console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

      async createLevel(levelDto:RmLevelDTO,isUpdate:boolean=false,@Req() request:Request): Promise<RmLevelResponseModel> {
        try {
        
        if (!isUpdate) {
            const levelEntity = await this.getLevelWithoutRelations(levelDto.levelName);
          if (levelEntity) {
            throw new RmLevelResponseModel(false,11104, 'Level already exists');
          }
        }else{
            const levelEntity = await this.getLevelWithoutRelationsForUpdate(levelDto.levelCode,levelDto.levelName,levelDto.levelId);
            if(levelEntity){
                if(levelEntity.levelId!=levelDto.levelId) {
                    throw new RmLevelResponseModel(false,11104, 'Level already exists');      
                }
            }
        }
        // else{
        //     const levelEntity = await this.getLevelWithoutRelations(levelDto.levelName);
        //     if(levelEntity){
        //         if(levelEntity.levelId!=levelDto.levelId) {
        //             throw new LevelResponseModel(false,11104, 'level already exists');      
        //         }
        //     }
        // }
        const levelEntity: RmLevel = this.levelAdapter.convertDtoToEntity(levelDto,isUpdate);
        const savedLevelEntity: RmLevel = await this.levelRepository.save(levelEntity);
        const savedLevelDto: RmLevelDTO = this.levelAdapter.convertEntityToDto(savedLevelEntity);
       
         if (savedLevelEntity) {
          const response = new RmLevelResponseModel(true,isUpdate ? 11100 : 11101,isUpdate? 'Level Updated Successfully':'Level Created Successfully',savedLevelDto);
          return response;
        } else {
          throw new RmLevelResponseModel(false,11106,'Level saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    async getAllLevels(): Promise<AllRmLevelsResponseModel> { 
        try {
            const levelDto: RmLevelDto[] = [];
            // retrieves all plants
            const levelEntities: RmLevel[] = await this.levelRepository.find({
                order: { levelName: "ASC" },
            });
            if (levelEntities.length>0) {
                levelEntities.forEach(levelEntity => {
                const convertedLevelDto: RmLevelDto = this.levelAdapter.convertEntityToDto(levelEntity);
                levelDto.push(convertedLevelDto);
                });
                const response = new AllRmLevelsResponseModel(true, 11208, "Level retrieved successfully", levelDto);
                return response;
            } else {
                throw new RmLevelResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getLevelByLevelId(levelIdRequest:RmLevelIdRequest): Promise<RmLevelResponseModel> { 
        try {
            const levelDto: RmLevelDto[] = [];
            // retrieves all plants
            const levelEntities = await this.levelRepository.findOne({
                where: { levelId:levelIdRequest.levelId },
            });
            if (levelEntities) {
                
                const convertedLevelDto = this.levelAdapter.convertEntityToDto(levelEntities);
               
                const response = new RmLevelResponseModel(true, 11208, "Level retrieved successfully", convertedLevelDto);
                return response;
            } else {
                throw new RmLevelResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async activateOrDeactivateLevel(levelReq: RmLevelRequest): Promise<RmLevelResponseModel> {
        try {
            const levelExists = await this.getLevelById(levelReq.levelId);
            if (levelExists) {
                if (levelReq.versionFlag !== levelExists.versionFlag) {
                    throw new RmLevelResponseModel(false,10113, 'Someone updated the current level information.Refresh and try again');
                } else {
                    
                        const levelStatus =  await this.levelRepository.update(
                            { levelId: levelReq.levelId },
                            { isActive: levelReq.isActive,updatedUser: levelReq.updatedUser });
                       
                        if (levelExists.isActive) {
                            if (levelStatus.affected) {
                                const levelResponse: RmLevelResponseModel = new RmLevelResponseModel(true, 10115, 'Level is de-activated successfully');
                                return levelResponse;
                            } else {
                                throw new RmLevelResponseModel(false,10111, 'Level is already deactivated');
                            }
                        } else {
                            if (levelStatus.affected) {
                                const levelResponse: RmLevelResponseModel = new RmLevelResponseModel(true, 10114, 'Level is activated successfully');
                                return levelResponse;
                            } else {
                                throw new RmLevelResponseModel(false,10112, 'level is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new RmLevelResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getLevelById(levelId: number): Promise<RmLevel> {
        //  console.log(employeeId);
            const Response = await this.levelRepository.findOne({
            where: {levelId: levelId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }

        async getAllLevelDropDown(): Promise<RmLevelDropDownResponseModel> {
            try {
                const levelDto: RmLevelDropDownDto[] = [];
                const levelEntities: RmLevel[] = await this.levelRepository.find({ select: ['levelId', 'levelName'], where: { isActive: true }})
    
    
                if (levelEntities && levelEntities.length > 0) {
                    levelEntities.forEach(rackEntity => {
                        levelDto.push(new RmLevelDropDownDto(rackEntity.levelId,rackEntity.levelName));
                    });
                    const response = new RmLevelDropDownResponseModel(true, 11108, "level retrieved successfully", levelDto);
                    return response;
                } else {
                    throw new RmLevelResponseModel(false,99998, 'Data not found');
                }
            } catch (err) {
                throw err;
            }
        }
    
        async getLevelWithoutRelationsForUpdate(levelCode:string,levelName: string,id:number): Promise<RmLevel> {
            const responseCode = await this.levelRepository.findOne({
                where: { levelCode: levelCode },
            });
            const responseNo = await this.levelRepository.findOne({
                where: {levelName: levelName },
            });
            if (responseCode || responseNo) {
                if(responseCode && responseNo){
                    if(responseCode.levelId == responseNo.levelId){
                        return responseCode;
                    }
                    else if( responseCode.levelId == id){
                        return responseNo;
                    }
                    else if( responseNo.levelId == id){
                        return responseCode;
                    }
                    else{
                        return responseCode;
                    }
                }
                else if(responseCode && !responseNo){
                    return responseCode;
                }
                else if(responseNo && !responseCode){
                    return responseNo;
                }
            } else {
                return null;
            }
           }


}
